import {useAuth} from '@apps-common/auth-react';
import {useGetRestrictions} from '@src/api/dataCollections/accessControl.ts';
import {useGetIMSUserStatus} from '@src/api/ims.js';
import {notifyError} from '@src/components/notifier/notify';
import {DateTime} from 'luxon';
import {useEffect} from 'react';

const usePlatformAccess = () => {
  const auth = useAuth();

  const platformQuery = useGetIMSUserStatus();

  const accountId = auth?.user?.claims?.pl_customer_account as string;
  const restrictionsQuery = useGetRestrictions(accountId, {
    enabled: !!accountId,
  });

  const isLoading = platformQuery.isLoading ?? restrictionsQuery.isLoading;
  const error = platformQuery.error ?? restrictionsQuery.error;

  useEffect(() => {
    if (error) {
      notifyError({data: {message: 'Error loading user permissions'}});
    }
  }, [error]);

  const platformAccess = platformQuery.data?.platformAccess;
  const hasPlatformAccess = platformQuery.error ? false : !!platformAccess;
  const accountHasExpired = platformAccess?.expiresAt
    ? DateTime.fromISO(platformAccess.expiresAt) < DateTime.now()
    : false;
  const restrictions =
    !error && !isLoading ? (restrictionsQuery.data ?? []) : [];

  return {
    accountHasExpired,
    dataCollections: {
      hasReadOnlyAccess: restrictions.length > 0,
      serviceUnavailable: hasPlatformAccess && !!restrictionsQuery.error,
    },
    error,
    hasPlatformAccess,
    isLoading,
  };
};

export default usePlatformAccess;
